module.exports = __webpack_public_path__ + "static/DSC_9426-1b287ac0524442122c658ff78b4da0d8.jpg";